import { PathConfig } from "./interface";

export const NEWS_LINEUP_SLUG = "news";

export const NEWSBAR_ATTRIBUTES = [
    "id",
    "title",
    "url",
    "external",
    "flags",
    "flag",
];

export const PATHS_WITH_NEWS_BAR: { [key: string]: PathConfig } = {
    homepage: {
        lineupSlug: NEWS_LINEUP_SLUG,
        attributes: NEWSBAR_ATTRIBUTES,
        url: "/news",
        moreCardTitle: "More from CBC News",
    },
};
